import SheetTile from 'components/SheetTile';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { useContext } from 'react';
import { ModalState } from 'records/ModalState';
import { Sheet } from 'records/Sheet';
import CalibrationModal from '../CalibrationModal';

type MapDrawingOptionProps = {
  sheet: Sheet;
};

const MapDrawingOption: React.FC<MapDrawingOptionProps> = ({
  sheet,
}: MapDrawingOptionProps) => {
  const currentVersion = sheet.versions.last(null);

  if (!currentVersion) {
    return null;
  }

  const { actions } = useContext(AppStoreContext);

  const onOptionClick = () => {
    const modalState = new ModalState({
      id: 'calibrateSheet',
      open: true,
      component: CalibrationModal,
      props: {
        sheetVersion: currentVersion,
      },
    });

    actions.createModal(modalState);
  };

  return (
    <div className="primary-blue bold cursor-pointer" onClick={onOptionClick}>
      <SheetTile sheet={sheet} selected={false} />
    </div>
  );
};

export default MapDrawingOption;
